import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cx-spinner"
}
const _hoisted_2 = { class: "cx-spinner__elements" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.loading)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "cx-spinner__element-1",
            style: _ctx.style1
          }, null, 4),
          _createVNode("div", {
            class: "cx-spinner__element-2",
            style: _ctx.style2
          }, null, 4)
        ])
      ]))
    : _createCommentVNode("", true)
}